import { NextPage } from "next";
import Policy from "@feature/policy";
import { UserConst } from "@constants/user-const";
import { AUTH } from "@constants/common";

const Page: NextPage = props =>
  Policy({ ...props, title: "정책 및 약관", breadcrumb: "", type: UserConst.policyType.PRIVACY, resource: AUTH.AUTH });

export default Page;
